<template>
  <VApp>
    <!-- header -->
    <Menu
      style="position: fixed"
      ref="menu"
      @change="menuTabChange"
      @switchLocale="switchLocale"
      @openMenu="openMenu"
    />

    <!-- conteúdo -->
    <VMain>
      <VContainer fluid class="ma-0 pa-0 fill-height">
        <!-- RouterView em Vue Router 4 aceita attrs e repassa para o componente da rota -->
        <RouterView
          :menuTab="menuTab"
          @menu-tab-change="menuTabChange"
          @saber-mais="knowMore()"
        />

        <!-- Cookie: em Vue 3/Vuetify 3 usa-se v-model:snackbar  -->
        <Cookie
          v-model:snackbar="showCookieBar"
          @cookie-accept="cookieAccept"
          @cookie-reject="cookieReject"
        />
      </VContainer>
    </VMain>

    <!-- menu mobile deslizante -->
    <VScrollYReverseTransition>
      <VContainer
        v-if="mobileMenuOpen"
        class="primary"
        fluid
        style="position: fixed; bottom: 10vh; width: 100%; border-top-left-radius: 10%; border-top-right-radius: 10%; z-index: 100; background-color: black;"
      >
        <VCard color="transparent" class="white--text" >
          <VCardTitle
            class="text-uppercase font-weight-bold text-h4 d-flex align-center justify-space-between"
            style="color:#fff"
          >
            <span>Menu</span>

            <VBtn
              icon
              variant="text"
              color="white"
              class="ml-auto"
              @click="mobileMenuOpen = false"
            >
              <VIcon size="x-large">mdi-close</VIcon>
            </VBtn>
          </VCardTitle>

          <VDivider color="white" />

          <VCardText class="white--text text-uppercase font-weight-bold text-body-1" style="color:#fff">
            <p
              class="ml-16"
              style="display: flex; justify-content: left;"
              @click="menuTabChange('who_we_are'); mobileMenuOpen = false;"
            >
              <VImg max-width="30px" max-height="30px" :src="icons.who" />
              <span class="ml-6">{{ $t('MENU.who_we_are') }}</span>
            </p>
          </VCardText>

          <VCardText class="white--text text-uppercase font-weight-bold text-body-1" style="color:#fff">
            <p
              class="ml-16"
              style="display: flex; justify-content: left;"
              @click="menuTabChange('advantages'); mobileMenuOpen = false;"
            >
              <VImg max-width="30px" :src="icons.adv" />
              <span class="ml-6">{{ $t('MENU.advantages') }}</span>
            </p>
          </VCardText>

          <VCardText class="white--text text-uppercase font-weight-bold text-body-1" style="color:#fff">
            <p
              class="ml-16"
              style="display: flex; justify-content: left;"
              @click="menuTabChange('subscriptions'); mobileMenuOpen = false;"
            >
              <VImg max-width="30px" :src="icons.subs" />
              <span class="ml-6 mt-1">{{ $t('MENU.subscription') }}</span>
            </p>
          </VCardText>

          <VCardText class="white--text text-uppercase font-weight-bold text-body-1" style="color:#fff">
            <p
              class="ml-16"
              style="display: flex; justify-content: left;"
              @click="registerContactEvent(); menuTabChange('contacts'); mobileMenuOpen = false;"
            >
              <VImg max-width="30px" :src="icons.contact" />
              <span class="ml-6">{{ $t('MENU.contact') }}</span>
            </p>
          </VCardText>

          <VCardText class="white--text text-uppercase font-weight-bold text-body-1" style="color:#fff">
            <p
              class="ml-16"
              style="display: flex; justify-content: left;"
              @click="$router.push('/blog'); mobileMenuOpen = false;"
            >
              <VImg max-width="30px" :src="icons.blog" />
              <span class="ml-6">{{ $t('MENU.blog') }}</span>
            </p>
          </VCardText>

          <VCardText class="white--text text-uppercase font-weight-bold text-body-1" style="color:#fff">
            <p
              class="ml-16"
              style="display: flex; justify-content: left;"
              @click="openReportlake"
            >
              <VImg max-width="30px" :src="icons.login" />
              <span class="ml-6">Login</span>
            </p>
          </VCardText>
        </VCard>
      </VContainer>
    </VScrollYReverseTransition>

    <!-- footers -->
    <VFooter
      class="d-none d-lg-block flex ma-0 pa-0"
      color="secondary"
      height="auto"
    >
      <Footer />
    </VFooter>

    <VFooter
      class="d-md-none ma-0 pa-0"
      color="secondary"
      style="z-index: 101; position: fixed;"
      height="auto"
      app
    >
      <Footer />
    </VFooter>
  </VApp>
</template>

<script>
import Footer from '@/views/Footer.vue'
import Menu from '@/components/header/Menu.vue'
import Cookie from '@/components/cookies/Cookie.vue'

// IMPORTA OS ICONES (evita src com caminhos e espaços)
import iconWho     from '@/assets/icons/icons/png/icons_Prancheta 1-05.png'
import iconAdv     from '@/assets/icons/icons/png/icons_Prancheta 1-38.png'
import iconSubs    from '@/assets/icons/icons/png/icons_Prancheta 1-143.png'
import iconContact from '@/assets/icons/icons/png/icons_Prancheta 1-228.png'
import iconBlog    from '@/assets/icons/icons/png/icons_Prancheta 1-198.png'
import iconLogin   from '@/assets/icons/icons/png/icons_Prancheta 1-32.png'

export default {
  name: 'Layout',
  components: { Menu, Footer, Cookie },

  data() {
    return {
      mobileMenuOpen: false,
      menuTab: '',
      showCookieBar: false,
      icons: {
        who: iconWho,
        adv: iconAdv,
        subs: iconSubs,
        contact: iconContact,
        blog: iconBlog,
        login: iconLogin
      }
    }
  },

  watch: {
    menuTab: {
      immediate: true,
      handler(val) {
        if (val == null || val === '' || val === 'who_we_are') return

        if (val === 'contacts') {
          this.menuTab = val
          this.$router.push('/' + this.$i18n.locale + '/contacts')
          return
        }

        if (val === 'blog') {
          this.menuTab = val
          this.$router.push('/' + this.$i18n.locale + '/blog')
          return
        }

        // âncoras internas
        if (val !== 'contacts') {
          this.menuTab = val
          if (this.$route.name != null) {
            this.$router.push('/' + this.$i18n.locale + '/#' + val)
          }
        }
      }
    },

    $route: {
      immediate: true,
      handler(val) {
        if (val == null) {
          document.title = 'Reportlake | Software de Gestão de Obra'
          return
        }
        if (val.name === 'Trial') {
          document.title = 'Trial | Reportlake - Software de Gestão de Obra'
          return
        }
        document.title = 'Reportlake | Software de Gestão de Obra'
      }
    }
  },

  mounted() {
    const cookie = this.$cookies.get('reportlake_website_cookie')
    if (cookie == null) this.showCookieBar = true

    if (this.$route.params.lang != null) {
      this.$i18n.locale = this.$route.params.lang
    }
  },

  methods: {
    openReportlake() {
      window.open('https://login.reportlake.com/', '_blank')
    },

    cookieReject() {
      this.$cookies.set('reportlake_website_cookie', null, '1s')
      this.showCookieBar = false
    },

    cookieAccept(ob) {
      this.$cookies.set('reportlake_website_cookie', JSON.stringify(ob), '7d')
      this.showCookieBar = false
    },

    switchLocale(l) {
      this.$i18n.locale = l
      this.$route.params.lang = this.$i18n.locale
      this.$router.push({ name: this.$router.currentRoute.name, params: this.$route.params })
    },

    knowMore() {
      this.$refs.menu?.contactTab?.()
    },

    registerContactEvent() {
      const cookie = this.$cookies.get('reportlake_website_cookie')
      if (!cookie || cookie.statistics === false) return

      this.$gtag.event('contact_tag', {
        event_category: 'Contactos',
        event_label: 'Contactos',
        value: 'contact_tag'
      })
    },

    openMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },

    menuTabChange(v) {
      this.menuTab = v
    },

    getVersion() {
      return process.env.VUE_APP_SECRET_VERSION
    },

    goTo(place) {
      if (place !== 'contacts' && place !== 'blog') {
        this.$router.push('/' + place)
        return
      }
      this.$router.push(place)
    }
  }
}
</script>

<style>
/* (mantém os teus estilos globais aqui se precisares) */
</style>
